/* eslint-disable @typescript-eslint/no-use-before-define */

export default class OperationRecord {
  account: string
  name: string
  logs: Log[] = []
  constructor (account: string, name: string) {
    this.account = account
    this.name = name
  }

  addLog = (time: string, desc: string) => {
    this.logs.push(new Log(time, desc))
  }
}

class Log {
  time: Date
  desc: string
  constructor (time: string, desc: string) {
    this.time = new Date(time)
    this.desc = desc
  }
}
